// fileUpload,downloadOrgResource
import {
    getImagingEngineerPhysician,
    imagingEngineer,
    getAllHospital,
    getAllDept,
    uploadOrgBegin,
    uploadOrgDone,
    listAllFiles,
    uploadSolveBegin,
    uploadSolveDone,
    downloadFile,
    delFile,
    getAllLog,
    addCaseLog,
    exportCustomCaseLog,
    getAllHospitalByPhysician,
    editCustomInfoPriority, corporation
} from '../../../service/service'
import axios from 'axios'

export default {
    name: 'custom',
    data: function () {
        return {
            data2: [],
            total: 0,
            patientName: '',
            dateOfSurgery: '',
            keywordSearch: '',
            columns1: [
                {
                    title: this.$t('Case ID'),
                    minWidth: 140, tooltip: true,
                    key: 'id'
                }, {
                    title: this.$t('sales rep'),
                    minWidth: 140, tooltip: true,
                    key: 'salesrep'
                }, {
                    title: this.$t('physician'),
                    minWidth: 140, tooltip: true,
                    key: 'physician'
                }, {
                    title: this.$t('specialty'),
                    minWidth: 60, tooltip: true,
                    key: 'specialty'
                }, {
                    title: this.$t('patient name'),
                    minWidth: 100, tooltip: true,
                    key: 'patientname'
                }, {
                    title: this.$t('hospital'),
                    minWidth: 100, tooltip: true,
                    key: 'hospitalName'
                }, {
                    title: this.$t('date of surgery'),
                    minWidth: 100, tooltip: true,
                    key: 'dateofsurgery'
                }, {
                    title: this.$t('priority'),
                    minWidth: 60, tooltip: true,
                    slot: 'priority'
                }, {
                    title: this.$t('status'),
                    minWidth: 80, tooltip: true,
                    key: 'status'
                }, {
                    title: this.$t('more info'),
                    minWidth: 60, tooltip: true,
                    slot: 'more'
                }
            ],
            data1: [],
            modal: false,
            txtComment: '',
            addcasemark :false,
            formItem: {
                physician: '',
                specialty: '',
                patientname: '',
                hospital: '',
                dateofsurgery: '',
                priority: false,
                representative: ''
            },
            formItem2: {
                physician: '',
                specialty: '',
                patientname: '',
                hospital: '',
                dateofsurgery: '',
                priority: false,
                representative: ''
            },
            note: '',
            ruleInline: {
                physician: [
                    {required: true, message: this.$t('Please select the hospital'), trigger: 'change'}
                ],
                patientname: [
                    {required: true, message: this.$t('Please fill in the patient name'), trigger: 'blur'}
                ],
                hospital: [
                    {required: true, message: this.$t('Please select the hospital'), trigger: 'change'}
                ],
                priority: [
                    {required: true, message: this.$t('Please select at priority'), trigger: 'change', type: 'boolean'}
                ]
            },
            modalNext: false,
            fileList: [],
            fileList2: [],
            fileList3: [],
            options: {
                target: axios.defaults.baseURL + 'api/common/uploadOrg',
                testChunks: false,
                chunkSize: 1024 * 1024 * 2,  //1MB
                simultaneousUploads: 1, //并发上传数
                fileParameterName: 'param',
                query: {
                    caseId: ""
                }
            },
            options2: {
                target: axios.defaults.baseURL + 'api/common/uploadSolve',
                testChunks: false,
                // autoStart: false,
                chunkSize: 1024 * 1024 * 2,  //1MB
                simultaneousUploads: 1, //并发上传数
                fileParameterName: 'param',
                query: {
                    caseId: ""
                }
            },
            showConfirmation: false,
            single: false,
            modal3: false,
            modal2: false,
            commentList: [1, 1, 1, 1, 1],
            modal1: false,
            modal6: false,
            showModifyModal: false,
            pagesize: 20,
            pageTo: "1",
            page: 1,
            showBackBtn: true,
            row: {},
            alert1: false,
            alert2: false,
            alert3: false,
            alert4: false,
            alert5: false,
            alert6: false,
            alert7: false,
            alert8: false,
            alert9: false,
            alert10: false,
            expeditedTotal: 0,
            arrTree: [],
            tempTree:[],
            salesRepresentativeList: [],
            physiciansList: [],
            hospitalList: [],
            hospitalList2: [],
            dataInfo: null,
            specialtylList: [],
            confirmSalesRep: '',
            confirmPhysician: '',
            confirmHospital: '',
            isUpload: false,
            chooseRow: [{'caseId': 'caseId'}],
            tipsCount: '',
            noticStatus: false,
            searchMark: false,
            timeoutId: ''
        }
    },
    methods: {
        yes10() {
            // console.log(this.dataInfo)
            editCustomInfoPriority({
                userId: this.token,
                priority: 'Expedited',
                id: this.tid,
                salesRepresentative: this.dataInfo.SalesId,
                physician: this.dataInfo.DocId,
            }).then(res => {
                if (res.code === '0') {
                    this.alert10 = false
                    this.$Spin.show({
                        render: (h) => {
                            return h('div', [
                                h('Icon', {
                                    'class': 'demo-spin-icon-load',
                                    props: {
                                        type: 'ios-loading',
                                        color: '#f48221',
                                        size: 18
                                    }
                                }),
                                h('div', {
                                    style: {
                                        color: '#f48221'
                                    },
                                }, 'Loading')
                            ])
                        }
                    });
                    addCaseLog({
                        userId: this.token,
                        caseId: this.tid,
                        logType: 'Converted to Expedited',
                        reason: ''
                    }).then(res => {
                        if (res.code === '0') {
                            imagingEngineer.custom.getCustomInfo({
                                id: this.tid
                            }).then(res => {
                                let code = parseInt(res.code)
                                if (!code) {
                                    this.dataInfo = JSON.parse(res.data)
                                    console.log(this.dataInfo)
                                }
                                getAllLog({
                                    userId: this.token,
                                    caseId: this.tid
                                }).then(res => {
                                    let code = parseInt(res.code)
                                    console.log(JSON.parse(res.data))
                                    let logList = []
                                    JSON.parse(res.data).forEach(i => {
                                        logList.push(JSON.parse(i))
                                    })
                                    console.log(logList)
                                    if (!code) {
                                        this.commentList = logList
                                    }
                                    this.modal2 = true
                                })
                            })
                        }
                    })
                    this.reloadView()
                }
            })
        },
        no10() {
            this.alert10 = false
        },
        changeToExpedited() {
            this.alert10 = true
        },
        toCsv() {
            console.log(JSON.stringify(this.arrTree))
            exportCustomCaseLog({
                "userId":this.token,
                "patientName": this.patientName,
                "startDateOfSurgery": this.dateOfSurgery[0],
                "endDateOfSurgery": this.dateOfSurgery[1],
                "keywordSearch": this.keywordSearch,
                "physicianList": JSON.stringify(this.arrTree)
            })
        },
        rowClass(row) {
            if (row._isHighlight) {
                // console.log(row)
                return "row-class"
            }
        },
        onSelectRow(row, index) {
            // console.log(this.$refs.tableJin.objData[index])
            // console.log(selection)
            if (!this.$refs.tableJin.objData[index]._isHighlight) {
                this.$refs.tableJin.objData[index]._isHighlight = true
                let obj = {
                    caseId: row.id
                }
                this.chooseRow.push(obj)
            } else {
                this.chooseRow.forEach((e, i) => {
                    if (row.id === e.id) {
                        this.chooseRow.splice(i, 1)
                    }
                })
                this.$refs.tableJin.objData[index]._isHighlight = false
            }
        },
        selectTree(e) {
            this.page = 1
            this.pageTo = 1
            let arr = []
            e.forEach(i => {
                if (!i.children) {
                    let obj = {
                        physicianID: i.id
                    }
                    arr.push(obj)
                }
            });
            this.arrTree = arr
            this.reloadView()
        },
        reloadView() {
            // console.log(1   )
            let obj = {
                "page": this.page,
                "limit": this.pagesize,
                "patientName": this.patientName,
                "startDateOfSurgery": this.dateOfSurgery[0],
                "endDateOfSurgery": this.dateOfSurgery[1],
                "keywordSearch": this.keywordSearch
            }
            if (this.arrTree.length) {
                obj["physicianList"] = JSON.stringify(this.arrTree)
            }
            imagingEngineer.custom.getCustomData(obj).then(res => {
                let code = parseInt(res.code)
                if (!code) {
                    let data = JSON.parse((res.data))
                    console.log("**********************")
                    console.log(data)
                    console.log("**********************")
                    console.log(JSON.stringify(data.list))
                    this.$Spin.hide();
                    if (data.list) {
                        console.log(JSON.stringify(data.list))
                        this.data1 = JSON.parse(data.list)
                        console.log(this.data1)
                    } else {
                        this.data1 = []
                    }
                    // console.log(JSON.parse(data.list))
                    this.total = data.totalAll
                    this.expeditedTotal = data.totalExpedited
                    this.$refs.elScrol.wrap.scrollTop = 0
                    this.$refs.elScrol.wrap.scrollLeft = 0
                    this.txtComment = ''
                }
            })
        },
        goPage() {
            if (this.pageTo) {
                let maxPage = Math.ceil(parseInt(this.total) / parseInt(this.pagesize))
                if (parseInt(this.pageTo) > maxPage) {
                    this.page = maxPage
                } else {
                    this.page = parseInt(this.pageTo)
                }
                this.pageTo = this.page
                this.reloadView()
            } else {
                this.pageTo = this.page
            }
        },
        manageSurgicalPlan() {
            this.options2.query.caseId = this.row.id
            // this.options.target = axios.defaults.baseURL + 'api/common/uploadResult'
            console.log(this.options.query.caseId)
            console.log(this.row.id)
            uploadSolveBegin({caseId: this.row.id}).then(res => {
                if (res.code === '0') {
                    // this.$Message.success('Success!');
                    this.alert9 = true
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
                this.$Spin.hide();
            })
            this.fileList2 = [];
            console.log("********"+this.row.id+"********")
            listAllFiles({caseId: this.row.id, fileType: 'result'}).then(res => {
                console.log(res)
                this.$Spin.hide();
                if (res.code === '0') {
                    console.log(JSON.parse(res.data))
                    this.fileList2 = JSON.parse(res.data)
                } else {
                    this.fileList2 = [];
                }
            })
        },
        goDownload(id, name) {
            // console.log(this.row)
            // downloadOrgResource({caseId:this.row.id})

            downloadFile({caseId: this.row.id, fileId: id, fileName: name})
        },
        manageSourceDICOM() {
            console.log(this.row)
            // this.options.query.caseId = this.row.id
            // uploadOrgBegin({caseId:this.row.id}).then(res=>{
            //     if(res.code === '0'){
            //         this.$Message.success('Success!');
            //         this.alert8 = true
            //     }else{
            //         this.$Message.warning(this.$t('fail'))
            //     }
            //     this.$Spin.hide();
            // })
            // this.$Spin.show();
            // downloadOrgResource({caseId:this.row.id})
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            this.fileList3 = [];
            listAllFiles({caseId: this.row.id, fileType: 'org'}).then(res => {
                console.log(res)
                this.$Spin.hide();
                if (res.code === '0') {
                    console.log(JSON.parse(res.data))
                    this.fileList3 = JSON.parse(res.data)
                } else {
                    this.fileList3 = [];
                }
            })
            this.alert8 = true
        },
        no7() {
            this.alert7 = false
        },
        yes7() {
            if (this.txtComment.length > 60000) {
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            console.log(this.txtComment)
            imagingEngineer.custom.opCaseStatus({
                userId: this.token,
                caseId: this.row.id,
                caseStatus: 'On Hold',
                remarks: this.txtComment
            }).then(res => {
                if (res.code === '0') {
                    this.alert7 = false
                    this.modal2 = false
                    this.reloadView();
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        onHold() {
            this.alert7 = true
        },
        no6() {
            this.alert6 = false
        },
        yes6() {
            imagingEngineer.custom.opCaseStatus({
                userId: this.token,
                caseId: this.row.id,
                caseStatus: 'Completed'
            }).then(res => {
                if (res.code === '0') {
                    this.alert6 = false
                    this.modal2 = false
                    addCaseLog({
                        userId: this.token,
                        caseId: this.tid,
                        logType: 'Case Completed',
                        reason: ''
                    }).then(res => {
                        console.log(res)
                        this.reloadView()
                    })
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        complete() {
            this.alert6 = true
        },
        no5() {
            this.alert5 = false
        },
        yes5() {
            if (this.txtComment.length > 60000) {
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            imagingEngineer.custom.opCaseStatus({
                userId: this.token,
                caseId: this.row.id,
                caseStatus: 'Processing',
                remarks: this.txtComment
            }).then(res => {
                if (res.code === '0') {
                    this.alert5 = false
                    this.modal2 = false
                    addCaseLog({
                        userId: this.token,
                        caseId: this.tid,
                        logType: 'Back to Processing',
                        remarks: this.txtComment
                    }).then(res => {
                        console.log(res)
                        this.reloadView()
                    })
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        backProcessing() {
            this.alert5 = true
        },
        no4() {
            this.alert4 = false
        },
        yes4() {
            imagingEngineer.custom.opCaseStatus({
                userId: this.token,
                caseId: this.row.id,
                caseStatus: 'Accept'
            }).then(res => {
                if (res.code === '0') {
                    this.reloadView()
                    this.alert4 = false
                    this.modal2 = false
                    addCaseLog({
                        userId: this.token,
                        caseId: this.tid,
                        logType: 'Begin case processing'
                    }).then(res => {
                        console.log(res)
                    })
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        acceptCase() {
            this.alert4 = true
        },
        no3() {
            this.alert3 = false
        },
        yes3() {
            if (this.txtComment.length > 60000) {
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            imagingEngineer.custom.opCaseStatus({
                userId: this.token,
                caseId: this.row.id,
                caseStatus: 'Rejected',
                remarks: this.txtComment
            }).then(res => {
                if (res.code === '0') {
                    this.reloadView()
                    this.alert3 = false
                    this.modal2 = false
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        rejectCase() {
            this.alert3 = true
        },
        no2() {
            this.alert2 = false
        },
        yes2() {
            if(this.txtComment.length > 60000){
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            imagingEngineer.custom.opCaseStatus({
                userId: this.token,
                caseId: this.row.id,
                caseStatus: 'Processing'
            }).then(res => {
                if (res.code === '0') {
                    this.reloadView()
                    this.alert2 = false
                    this.modal2 = false
                    addCaseLog({
                        userId: this.token,
                        caseId: this.tid,
                        logType: 'Resume case processing',
                        reason: ''
                    }).then(res => {
                        console.log(res)
                    })
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        resume() {
            this.alert2 = true
        },
        no1() {
            this.alert1 = false
        },
        yes1() {
            if (this.txtComment.length > 60000) {
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            let userName = sessionStorage.getItem('userName')
            imagingEngineer.custom.customRequestCancellation({
                id: this.tid,
                count: this.txtComment,
                userid: this.token,
                currentUserName: userName,
            }).then(res => {
                if (res.code === '0') {
                    this.reloadView()
                    this.alert1 = false
                    this.modal2 = false
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        cancelCase() {
            this.alert1 = true
        },
        changePageSize(size) {
            this.page = 1
            this.pageTo = 1
            this.pagesize = size
            this.reloadView()
        },
        changePage(e) {
            // console.log(e)
            this.page = e
            this.pageTo = e
            this.reloadView()
        },
        ok6() {
            this.modal6 = false
        },
        cancel6() {
            this.modal6 = false
        },
        changePatientName() {
            var that = this;
            if (this.searchMark) {
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(function () {
                    that.page = 1;
                    that.reloadView();
                }, 1000);
            } else {
                this.timeoutId = setTimeout(function () {
                    that.page = 1;
                    that.reloadView();
                }, 1000);
                this.searchMark = true;
            }
        },
        requestCancellation() {
            this.modal6 = true
        },
        ok5() {
            if (this.note.length > 60000) {
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }

            let p = {
                "userId": this.token,
                "salesRepresentative": this.dataInfo.SalesId,
                "id": this.tid,
                "physician": this.formItem2.physician,
                "patientName": this.formItem2.patientname,
                "hospital": this.formItem2.hospital,
                "dateOfSurgery": this.formItem2.dateofsurgery,
                "notes": this.note,
                // "flieList": JSON.stringify(this.fileList)
            }
            // console.log(this.dataInfo.CaseUrgent)
            if (this.dataInfo.CaseUrgent === 'expedited') {
                p.priority = 'Expedited'
            } else {
                p.priority = 'Standard'
            }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            imagingEngineer.custom.editCustomInfo(p).then(res => {
                console.log(res)
                let code = parseInt(res.code)
                this.$Spin.hide();
                if (!code) {
                    this.modal = false
                    this.modalNext = false
                    this.note = ''
                    this.formItem2.physician = ''
                    this.formItem2.specialty = ''
                    this.formItem2.patientname = ''
                    this.formItem2.hospital = ''
                    this.formItem2.dateofsurgery = ''
                    this.formItem2.priority = false
                    this.showConfirmation = false
                    // this.$Message.success(this.$t('success'))
                    this.modal6 = false
                    // this.modal2 = false
                    imagingEngineer.custom.getCustomInfo(p).then(res => {
                        let code = parseInt(res.code)
                        if (!code) {
                            this.dataInfo = JSON.parse(res.data)
                            console.log(this.dataInfo)
                        }
                        getAllLog({
                            userId: this.token,
                            caseId: this.tid
                        }).then(res => {
                            this.showModifyModal = false
                            let code = parseInt(res.code)
                            this.$Spin.hide();
                            console.log(JSON.parse(res.data))
                            let logList = []
                            JSON.parse(res.data).forEach(i => {
                                logList.push(JSON.parse(i))
                            })
                            console.log(logList)
                            if (!code) {
                                this.commentList = logList
                            }
                            this.modal2 = true
                        })
                    })
                } else if (res.code === '-100') {
                    this.$Message.error('Operation without permission !')
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
            })
        },
        cancel5() {
            this.modal2 = false
            this.showModifyModal = false
            this.formItem2.physician = ''
            this.formItem2.hospital = ''
            this.formItem2.patientname = ''
            this.formItem2.dateofsurgery = ''
            this.note = ''
        },
        showModify() {
            this.showModifyModal = true
            console.log(this.dataInfo)
            this.formItem2.physician = this.dataInfo.DocId
            console.log(this.hospitalList)
            // this.hospitalList.forEach(i=>{
            //     if(i.hospitalId === )
            // })
            this.formItem2.hospital = this.dataInfo.CaseHos
            this.formItem2.patientname = this.dataInfo.CasePatient
            this.formItem2.dateofsurgery = this.dataInfo.CaseSurgdate
            this.showModifyModal = true
            getAllHospitalByPhysician({
                userId: this.token,
                doctorId: this.dataInfo.DocId
            }).then(res => {
                let code = parseInt(res.code)
                if (!code) {
                    let hosList = JSON.parse(res.data)
                    console.log(hosList)
                    this.hospitalList2 = hosList
                }
            })
        },
        ok4() {
            if (this.txtComment.length > 60000) {
                this.$Message.error('Comment should be no longer than 60,000 characters.')
                return;
            }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            imagingEngineer.custom.addCustomComment({
                userId:this.token,
                id:this.tid,
                count:this.txtComment
            }).then(res=>{
                console.log(res)
                this.$Spin.hide();
                let code = parseInt(res.code)
                if(!code){
                    this.modal1 = false
                    this.txtComment = ''
                    this.tname = ''
                    getAllLog({
                        userId: this.token,
                        caseId: this.tid
                    }).then(res => {
                        let code = parseInt(res.code)
                        this.$Spin.hide();
                        console.log(JSON.parse(res.data))
                        let logList = []
                        JSON.parse(res.data).forEach(i => {
                            logList.push(JSON.parse(i))
                        })
                        console.log(logList)
                        if (!code) {
                            this.commentList = logList
                        }
                        this.modal1 = false
                        if (this.showModifyModal){
                            this.modal2 = true
                        }
                    })
                }else{
                    this.$Message.warning(this.$t('fail'))
                }
            })
            // corporation.custom.addCustomComment(obj).then(res=>{
            //     console.log(res)
            //     let code = parseInt(res.code)
            //     if(!code){
            //         this.modal1 = false
            //         this.txtComment = ''
            //         this.tname = ''

            //     }else{
            //         this.$Message.warning(this.$t('fail'))
            //     }
            // })
        },
        cancel4() {
            this.modal1 = false
        },
        addComment(row, index) {
            console.log(row)
            console.log(index)
            this.modal1 = true
        },
        showDetail(row) {
            this.row = row
            this.tid = row.id
            let obj = this.options
            obj.query = {
                caseId: row.id
            }
            // console.log(obj)
            this.options = obj
            console.log(this.options)
            this.tname = row.name
            let p = {
                id: this.tid
            }
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Loading')
                    ])
                }
            });
            imagingEngineer.custom.getCustomInfo(p).then(res => {
                let code = parseInt(res.code)
                if (!code) {
                    this.dataInfo = JSON.parse(res.data)
                    console.log(this.dataInfo)
                }
                getAllLog({
                    userId: this.token,
                    caseId: this.tid
                }).then(res => {
                    let code = parseInt(res.code)
                    this.$Spin.hide();
                    console.log(JSON.parse(res.data))
                    let logList = []
                    JSON.parse(res.data).forEach(i => {
                        logList.push(JSON.parse(i))
                    })
                    console.log(logList)
                    if (!code) {
                        this.commentList = logList
                    }
                    this.modal2 = true
                })
            })
        },
        ok3() {
            this.modal3 = false
            this.fileList = []
            this.modalNext = false
            this.reloadView()
        },
        fileAdded(file) {
            console.log(file)
            uploadOrgDone({caseId: this.options.query.caseId}).then(res => {
                this.$Spin.hide();
                if (res.code === '0') {
                    // this.modalNext = true
                    console.log("*****************"+this.showModifyModal)
                    if (!this.showModifyModal) {
                        this.isUpload = false

                        addCaseLog({
                            userId: this.token,
                            caseId: this.tid,
                            logType: 'Additional Data Uploaded',
                            remarks: ''
                        }).then(res => {
                            console.log(res)
                            if (this.noticStatus) {
                                let userName = sessionStorage.getItem('userName')
                                imagingEngineer.custom.uploadNewFileNotice({
                                    id: this.options.query.caseId,
                                    currentUserName: userName
                                }).then(() => {
                                    this.noticStatus = false
                                })
                            }
                        })
                    }
                    this.modal = false
                    this.modalNext = false
                    this.note = ''
                    this.formItem.physician = ''
                    this.formItem.specialty = ''
                    this.formItem.patientname = ''
                    this.formItem.hospital = ''
                    this.formItem.dateofsurgery = ''
                    this.formItem.priority = false
                    this.showConfirmation = false
                    this.modal3 = true
                    this.modal6 = false
                    this.fileList3 = [];
                    console.log("case Id ******:"+this.row.id)
                    listAllFiles({caseId: this.row.id, fileType: 'org'}).then(res => {
                        console.log(res)
                        this.$Spin.hide();
                        if (res.code === '0') {
                            console.log(JSON.parse(res.data))
                            this.fileList3 = JSON.parse(res.data)
                        } else {
                            this.fileList3 = [];
                        }
                    })
                }
            })
        },
        handleUpload2(file) {
            console.log(file)
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Uploading')
                    ])
                }
            });
            let arr = this.fileList2;
            arr.push(file)
            this.fileList2 = arr
            console.log(this.fileList2)

            return false;
        },
        fileAdded2() {
            // let userName = sessionStorage.getItem('userName')
            uploadSolveDone({caseId: this.options2.query.caseId}).then(res => {
                if (res.code === '0') {
                    this.$Spin.hide();
                    // this.modalNext = true
                    this.fileList2 = [];

                    listAllFiles({caseId: this.row.id, fileType: 'result'}).then(res => {
                        console.log(res)
                        this.$Spin.hide();
                        if (res.code === '0') {
                            console.log(JSON.parse(res.data))
                            this.fileList2 = JSON.parse(res.data)
                        } else {
                            this.fileList2 = [];
                        }
                    })
                    addCaseLog({
                        userId: this.token,
                        caseId: this.tid,
                        logType: 'Surgical plan uploaded',
                        remarks: ''
                    }).then(res => {
                        console.log(res)
                    })
                    this.isUpload = false
                    this.$Message.success('The surgical plan has been uploaded.')
                } else {
                    this.$Message.error('An error occured when uploading the surgical plan')
                }
            })
            // imagingEngineer.custom.uploadNewFileNotice({
            //     id:this.options2.query.caseId,
            //     currentUserName:userName
            // }).then(()=>{
            //     this.noticStatus = false
            // })
        },
        delFile(i) {
            this.fileList.splice(i, 1)
        },
        delFile2(i,index) {
            var fileId = i.fileId;
            console.log(i)
            var that = this;
            delFile({fileId: fileId}).then(function(){
                that.fileList3.splice(index, 1);
            });
        },
        delFile3(i,index) {
            var fileId = i.fileId;
            console.log(i)
            var that = this;
            delFile({fileId: fileId}).then(function(){
                that.fileList2.splice(index, 1);
            });
        },
        handleUpload(file) {
            console.log(file)
            // let p = {
            //     param: JSON.stringify(file),
            //     caseId: this.options.query.caseId
            // }
            // fileUpload(p).then(res=>{
            //     console.log(res)
            // })
            let arr = this.fileList;
            arr.push(file)
            this.fileList = arr
            console.log(this.fileList)
            return false;
        },
        back() {
            this.modalNext = false
        },
        handleSubmit(name) {
            // this.$Spin.show();
            this.$refs[name].validate((valid) => {
                if (valid) {
                    // this.$Message.success('Success!');
                    this.modalNext = true
                } else {
                    this.$Message.error('Please ﬁx the error(s) indicated below.');
                }
            })
        },
        ok1() {
            this.single  =false;
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                color: '#f48221',
                                size: 18
                            }
                        }),
                        h('div', {
                            style: {
                                color: '#f48221'
                            },
                        }, 'Uploading')
                    ])
                }
            });
            let p = {
                // "salesRepresentative": this.formItem.representative,
                "userId": this.token,
                "physician": this.formItem.physician,
                "patientName": this.formItem.patientname,
                "hospital": this.formItem.hospital,
                "dateOfSurgery": this.formItem.dateofsurgery,
                // "priority": this.formItem.priority,
                "notes": this.note,
                // "flieList": JSON.stringify(this.fileList)
            }
            if (this.formItem.priority) {
                p.priority = 'Expedited'
            } else {
                p.priority = 'Standard'
            }
            imagingEngineer.custom.addNewCase(p).then(res => {
                console.log(res)
                let code = parseInt(res.code)
                if (!code) {
                    addCaseLog({
                        userId: this.token,
                        caseId: this.tid,
                        logType: 'Case Submitted',
                        remarks: this.note
                    }).then(res => {
                        console.log(res)
                    })
                    this.options.query.caseId = res.caseId
                    this.tipsCount = 'A new case has been created.'
                    uploadOrgBegin({caseId: res.caseId}).then(res => {
                        if (res.code === '0') {
                            let uploaderInstance = this.$refs.uploader.uploader
                            uploaderInstance.resume()
                        } else {
                            this.$Message.warning(this.$t('fail'))
                        }
                        // this.$Spin.hide();
                    })
                }
            })
            // this.modal = false
            // this.modalNext = false
            // this.note = ''
            // this.formItem.physician = ''
            // this.formItem.specialty = ''
            // this.formItem.patientname = ''
            // this.formItem.hospital = ''
            // this.formItem.dateofsurgery = ''
            // this.formItem.priority = false
            // this.showConfirmation = false
            // this.modal3 = true
            // this.modal6 = false
            // let p ={
            //     "salesRepresentative": this.token,
            //     "physician": this.formItem.physician,
            //     "patientName": this.formItem.patientname,
            //     "hospital": this.formItem.hospital,
            //     "dateOfSurgery": this.formItem.dateofsurgery,
            //     "priority": this.formItem.priority,
            //     "notes": this.note,
            //     "flieList": JSON.stringify(this.fileList)
            // }
            // if(this.formItem.priority){
            //     p.priority = 'expedited'
            // }else{
            //     p.priority = 'standard'
            // }
            // imagingEngineer.custom.addNewCase(p).then(res=>{
            //     console.log(res)
            //     let code = parseInt(res.code)
            //     if(!code){

            //         this.reloadView()
            //     }
            // })
        },
        ok() {
            if (!this.showModifyModal && this.addcasemark) {
                this.showConfirmation = true
                // const uploaderInstance = this.$refs.uploader.uploader
                // console.log(uploaderInstance.upload)
            } else {
                this.addcasemark = false;
                let uploaderInstance = this.$refs.uploader.uploader
                uploaderInstance.resume()
                this.$Spin.show({
                    render: (h) => {
                        return h('div', [
                            h('Icon', {
                                'class': 'demo-spin-icon-load',
                                props: {
                                    type: 'ios-loading',
                                    color: '#f48221',
                                    size: 18
                                }
                            }),
                            h('div', {
                                style: {
                                    color: '#f48221'
                                },
                            }, 'Uploading')
                        ])
                    }
                });
                this.isUpload = true
                this.modal = false;
            }
        },
        cancel1() {
            this.showConfirmation = false
        },
        onModalCancel() {
            if (!this.showModifyModal) {
                this.formItem.physician = ''
                this.formItem.specialty = ''
                this.formItem.patientname = ''
                this.formItem.hospital = ''
                this.formItem.dateofsurgery = ''
                this.formItem.priority = false
            }
            if (this.modalNext) {
                let uploaderInstance = this.$refs.uploader.uploader
                uploaderInstance.cancel()
            }
            this.fileList = []
            this.modal = false
            this.modalNext = false
        },
        cancel() {
            if (!this.showModifyModal) {
                this.formItem.physician = ''
                this.formItem.specialty = ''
                this.formItem.patientname = ''
                this.formItem.hospital = ''
                this.formItem.dateofsurgery = ''
                this.formItem.priority = false
            }
            if (this.modalNext) {
                let uploaderInstance = this.$refs.uploader.uploader
                uploaderInstance.cancel()
            }
            this.fileList = []
            this.modal = false
            this.modalNext = false
        },
        addCase2() {
            this.options.query.caseId = this.dataInfo.CaseId
            // console.log(this.options.query.caseId)
            this.tipsCount = 'Additional DICOM files have been uploaded.'
            this.noticStatus = true
            console.log("*******************")
            uploadOrgBegin({caseId: this.dataInfo.CaseId}).then(res => {
                if (res.code === '0') {
                    // this.$Message.success('Success!');
                    this.showBackBtn = false
                    this.modalNext = true
                    this.modal = true
                } else if (res.code === '-100') {
                    this.$Message.error('No permission to perform this operation.')
                } else {
                    this.$Message.warning(this.$t('fail'))
                }
                this.$Spin.hide();
            })
        },
        addCase() {
            this.modal = true
            this.showBackBtn = true
            this.addcasemark = true;
        },
        // download(row){
        //     // this.$Spin.show();
        //     // downloadResultResource({caseId:row.id}).then(res=>{
        //     //     if(res.code === '0'){
        //     //         this.$Spin.hide();
        //     //     }
        //     // })
        // },
        dateChange2(e) {
            this.formItem2.dateofsurgery = e
        },
        dateChange1(e) {
            this.formItem.dateofsurgery = e
        },
        showDate() {
            var that = this;
            if (this.searchMark) {
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(function () {
                    that.page  = 1;
                    that.reloadView();
                }, 2000);
            } else {
                this.timeoutId = setTimeout(function () {
                    that.page  = 1;
                    that.reloadView();
                }, 2000);
                this.searchMark = true;
            }
        },
        dateChange(e) {
            this.dateOfSurgery = e
            var that = this;
            if (this.searchMark) {
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(function () {
                    that.page  = 1;
                    that.reloadView();
                }, 2000);
            } else {
                this.timeoutId = setTimeout(function () {
                    that.page  = 1;
                    that.reloadView();
                }, 2000);
                this.searchMark = true;
            }
        },
        selectSales(e) {
            if (e !== undefined) {
                this.confirmSalesRep = e.label
            }
        },
        selectPhysician(e) {
            if (e !== undefined) {
                console.log(e)
                this.confirmPhysician = e.label
                this.formItem.hospital = ''
                this.formItem2.hospital = ''
                getAllHospitalByPhysician({userId: this.token, doctorId: e.value}).then(res => {
                    let code = parseInt(res.code)
                    if (!code) {
                        let hosList = JSON.parse(res.data)
                        console.log(hosList)
                        this.hospitalList2 = hosList
                    }
                })
            }

        },
        selectHospital(e) {
            if (e !== undefined) {
                this.confirmHospital = e.label
            }
        }
    },
    created() {

    },
    mounted() {
        this.token = sessionStorage.getItem('token') || sessionStorage.getItem('token')
        // console.log(token)
        getAllDept({UserUID: this.token}).then(res => {
            this.specialtylList = res.Dept
        })
        getAllHospital({UserUID: this.token}).then(res => {
            let code = parseInt(res.code)
            if (!code) {
                let hosList = JSON.parse(res.data)
                console.log(hosList)
                this.hospitalList = hosList
            }
        })
        let arr = [{
            title: 'All Physicians',
            id: 0,
            children: [],
            expand: true
        }]
        getImagingEngineerPhysician({UserUID: this.token}).then(res => {
            console.log(res)
            this.physiciansList = res.Physician
            let arr2 = []
            res.Physician.forEach(i => {
                let obj = {
                    title: i.DocName,
                    id: i.DocId,
                    expand: true
                }
                let objtemp = {
                    physicianID: i.DocId
                }
                arr2.push(objtemp)
                arr[0].children.push(obj)
            })

            this.data2 = arr
            this.arrTree = arr2
            console.log(this.arrTree+"********")
            this.reloadView()
        })
        this.$Spin.show({
            render: (h) => {
                return h('div', [
                    h('Icon', {
                        'class': 'demo-spin-icon-load',
                        props: {
                            type: 'ios-loading',
                            color: '#f48221',
                            size: 18
                        }
                    }),
                    h('div', {
                        style: {
                            color: '#f48221'
                        },
                    }, 'Loading')
                ])
            }
        });
        this.$Spin.hide();
        // eslint-disable-next-line no-irregular-whitespace
        let h = document.body.clientWidth
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal-details').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        document.querySelectorAll('.custom-modal').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })

        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal-case').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal2').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal1').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        window.onresize = function () {
            document.querySelectorAll('.custom-modal').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            // console.log(h/1920 * 100 + '%')
            document.querySelectorAll('.custom-modal-details').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal-case').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal2').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal1').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
        }
    }
}
